import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listimagebatch',
  templateUrl: './listimagebatch.component.html',
  styleUrls: ['./listimagebatch.component.css']
})
export class ListimagebatchComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  Error502 = `
  {
    "message": "Internal server error"
  }
  `
  
  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
        this.copyButton = false;
        this.copiedButton = true;
        // After a few seconds, reset the button states
        setTimeout(() => {
          this.copyButton = true;
          this.copiedButton = false;
        }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }


  requestData = `
  curl -X GET https://api.optimusdrive.ai/image/v1/batch \ -H "Content-Type: application/json" \ -H 'authorization: XXX' 
 
 `

  sucessData = `
  {
    "data": {
      "ImageBatches": [
        {
          "id": "string",
          "user_id": "string",
          "customer_type": "string",
          "callback_params": {
            "callback_url": "string",
            "custom_data": "object"
          },
          "collections": "string",
          "crunch_mode": "string",
          "urls": [
            {
              "input_url": "string",
              "output_url": "string",
              "filename": "string",
              "original_size": "string",
              "output_size": "string",
              "input_width": "string",
              "input_height": "string",
              "output_width": "string",
              "output_height": "string",
              "status": "string",
              "thumbnail": "string"
            }
          ],
          "created_at": "string",
          "completed_at": "string",
          "updated_at": "string",
          "pre_processing_started_at": "string",
          "pre_processing_completed_at": "string",
          "pre_processing_time": "string",
          "post_processing_started_at": "string",
          "post_processing_completed_at": "string",
          "post_processing_time": "string",
          "upscaling_submitted_at": "string",
          "upscaling_started_at": "string",
          "upscaling_completed_at": "string",
          "upscaling_time": "string",
          "created_at_user_id": "string",
          "sort": "string",
          "status": "string",
          "source": "string"
        }
      ],
      "Count": "integer",
      "LastEvaluatedKey": {
        "id": "string",
        "user_id": "string",
        "created_at_user_id": "string"
      },
      "ScannedCount": "integer"
    },
    "message": "Batch details fetched successfully"
  }`

  Error401x = `
  {
    "message":"Unauthorized"
  }`



}
